const weightedPackageTypes = [
  {
    sizeTuples: [{ size: 0.5, unit: "g" }],
    label: "½ g",
    legacyUnit: "HalfGram"
  },
  {
    sizeTuples: [{ size: 1, unit: "g" }],
    label: "1 g",
    legacyUnit: "Gram"
  },
  {
    sizeTuples: [{ size: 2, unit: "g" }],
    label: "2 g",
    legacyUnit: "TwoGrams"
  },
  {
    sizeTuples: [
      { size: 3.5, unit: "g" },
      { size: 3.4, unit: "g" },
      { size: 0.125, unit: "oz" },
      { size: 1, unit: "1/8oz" }
    ],
    label: "⅛ oz",
    legacyUnit: "Eighth"
  },
  {
    sizeTuples: [
      { size: 7, unit: "g" },
      { size: 0.25, unit: "oz" },
      { size: 1, unit: "1/4oz" }
    ],
    label: "¼ oz",
    legacyUnit: "Quarter"
  },
  {
    sizeTuples: [
      { size: 0.5, unit: "oz" },
      { size: 14, unit: "g" },
      { size: 1, unit: "1/2oz" }
    ],
    label: "½ oz",
    legacyUnit: "Half"
  },
  {
    sizeTuples: [
      { size: 1, unit: "oz" },
      { size: 28, unit: "g" }
    ],
    label: "1 oz",
    legacyUnit: "Ounce"
  }
];

// Only used in cases where all size info is stored on the packageUnit (and size = 1)
// e.g. 100mg -> 100 mg, 1Gram -> 1 gram, 1/4G -> 1/4 G, 1.75Gram -> 1.75 Gram
function packageUnitOnlyDisplay(packageUnit) {
  const match = String(packageUnit).match(
    /^((?:\d{1,4})|(?:\d.\d{1,2}))\s?(\w{1,5})$/
  );

  if (match) {
    const [_, size, unit] = match; // eslint-disable-line no-unused-vars

    return size && unit ? `${size} ${unit}` : packageUnit;
  } else {
    return packageUnit;
  }
}

function getVariantLabel({ packageUnit, packageSize = 1 }) {
  const packageUnitLower = String(packageUnit)
    .toLowerCase()
    .replace(/\s+/, "");

  if (packageUnitLower === "one" || packageUnitLower === "each") {
    return packageSize > 1 ? `pack of ${packageSize}` : "each";
  }

  const packageType = weightedPackageTypes.find(p => {
    if (
      p.sizeTuples.find(({ size, unit }) => {
        return size === parseFloat(packageSize) && unit === packageUnitLower;
      })
    ) {
      return true;
    } else {
      // Half Gram/HalfGram/Two Grams/TwoGrams
      return p.legacyUnit === String(packageUnit).replace(/\s/g, "");
    }
  });

  if (packageType) {
    return packageType.label;
  } else {
    return packageSize !== 1
      ? `${packageSize} ${packageUnit}`
      : packageUnitOnlyDisplay(packageUnit);
  }
}

function convertLegacyVariant(variant) {
  if (variant.packageUnit.toLowerCase() === "one") {
    return Object.assign({}, variant, { packageUnit: "each" });
  }

  const packageType = weightedPackageTypes.find(p => {
    return p.legacyUnit === String(variant.packageUnit).replace(/\s/g, "");
  });

  if (packageType) {
    const { size, unit } = packageType.sizeTuples[0];

    return Object.assign({}, variant, {
      packageSize: size,
      packageUnit: unit
    });
  }

  return variant;
}

export { convertLegacyVariant as c, getVariantLabel as g, weightedPackageTypes as w };
